export default "__VITE_ASSET__BGqPLBo0__"